import { Link } from '@mui/material';
import React from 'react';

const DataGridContactPhone = ({ phone }) => {
	return phone ? (
		<Link
			href={`tel:${phone.replace(/\s/g, '')}`}
			underline='hover'
			sx={{
				cursor: 'pointer',
				color: 'inherit',
				'&:hover': {
					color: 'primary.main',
				},
			}}
			onClick={(e) => e.stopPropagation()}
		>
			{phone}
		</Link>
	) : (
		<></>
	);
};

export default DataGridContactPhone;
